export default {
    en: new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }),
    es: new Intl.NumberFormat('es-ES', { maximumSignificantDigits: 3 }),
    ja: new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 3 })
};
